var _rect, _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeTenantLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 38,
    viewBox: "0 0 188 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    fill: "#192BC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 26.4844V30H10.5625V27L17.9219 19.1094C18.6615 18.2865 19.2448 17.5625 19.6719 16.9375C20.099 16.3021 20.4062 15.7344 20.5938 15.2344C20.7917 14.724 20.8906 14.2396 20.8906 13.7812C20.8906 13.0938 20.776 12.5052 20.5469 12.0156C20.3177 11.5156 19.9792 11.1302 19.5312 10.8594C19.0938 10.5885 18.5521 10.4531 17.9062 10.4531C17.2188 10.4531 16.625 10.6198 16.125 10.9531C15.6354 11.2865 15.2604 11.75 15 12.3438C14.75 12.9375 14.625 13.6094 14.625 14.3594H10.1094C10.1094 13.0052 10.4323 11.7656 11.0781 10.6406C11.724 9.50521 12.6354 8.60417 13.8125 7.9375C14.9896 7.26042 16.3854 6.92188 18 6.92188C19.5938 6.92188 20.9375 7.18229 22.0312 7.70312C23.1354 8.21354 23.9688 8.95312 24.5312 9.92188C25.1042 10.8802 25.3906 12.026 25.3906 13.3594C25.3906 14.1094 25.2708 14.8438 25.0312 15.5625C24.7917 16.2708 24.4479 16.9792 24 17.6875C23.5625 18.3854 23.0312 19.0938 22.4062 19.8125C21.7812 20.5312 21.0885 21.276 20.3281 22.0469L16.375 26.4844H26.125Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 17.5,
    x2: 188,
    y2: 17.5,
    stroke: "#192BC2",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTenantLine2);
export default __webpack_public_path__ + "static/media/Home.Tenant.Line 2.53f3d182ee7bfb1780346109ea212a80.svg";
export { ForwardRef as ReactComponent };